// export const regionConfig = {
//     US: {
//       aws_project_region: "us-west-2",
//       aws_cognito_region: "us-west-2",
//       aws_user_pools_id: "us-west-2_Vz5tDjg3y",
//       aws_user_pools_web_client_id: "5lj1cimcdk1p89r20ecpcqdh3b",
//       oauth: {
//         domain: "https://us-west-2vz5tdjg3y.auth.us-west-2.amazoncognito.com",
//         scope: ["email", "openid", "phone","profile"],
//         responseType: "code",
//         redirectSignIn: "https://unicorn.srvql.com/",
//         redirectSignOut: "https://support.servqualit.com/",
//       },
//     },
//     IN: {
//       aws_project_region: "ap-south-1",
//       aws_cognito_region: "ap-south-1",
//       aws_user_pools_id: "ap-south-1_nbQYwCpEz",
//       aws_user_pools_web_client_id: "5tekknmkii3lpsamv4tasmd3ru",
//       oauth: {
//         domain: "https://ap-south-1nbqywcpez.auth.ap-south-1.amazoncognito.com",
//         scope: ["email", "openid", "phone","profile"],
//         responseType: "code",
//         redirectSignIn: "https://unicorn.srvql.com/",
//         redirectSignOut: "https://unicorn.srvql.com/",
//       },
//     },
//     GB: {
//       aws_project_region: "eu-west-1",
//       aws_cognito_region: "eu-west-1",
//       aws_user_pools_id: "eu-west-1_dVg45Dujp",
//       aws_user_pools_web_client_id: "37s0h2sugb7fb4d141qknsr1q4",
//       oauth: {
//         domain: "https://servqualit.auth.eu-west-1.amazoncognito.com",
//         scope: ["email", "openid", "phone", "profile"],
//         responseType: "code",
//         redirectSignIn: "https://unicorn.srvql.com/",
//         redirectSignOut: "https://unicorn.srvql.com/",
//       },
//     },
//       AE: {
//       aws_project_region: "me-central-1",
//       aws_cognito_region: "me-central-1",
//       aws_user_pools_id: "me-central-1_JbYqzYCuw",
//       aws_user_pools_web_client_id: "35pq7v7sffiihk9lbqjuorpe1p",
//       oauth: {
//         domain: "https://me-central-1jbyqzycuw.auth.me-central-1.amazoncognito.com",
//         scope: ["email", "openid", "phone", "profile"],
//         responseType: "code",
//         redirectSignIn: "https://unicorn.srvql.com/",
//         redirectSignOut: "https://unicorn.srvql.com/",
//       },
//     },
//   };
  
//   // Function to detect the user's region using CloudFront API Gateway
//   const detectUserRegion = async () => {
//     try {
//       // Check if the region is already stored in sessionStorage
//       let userRegion = sessionStorage.getItem("userRegion");
  
//       if (!userRegion) {
//         // Fetch region from CloudFront API Gateway
//         const response = await fetch("https://d1oul0ahiu5rh1.cloudfront.net");
//         const data = await response.json();
  
//         // Extract the region from CloudFront-Viewer-Country header
//         userRegion = data["CloudFront-Viewer-Country"] || "GB"; // Default to UK
  
//         // Store region in sessionStorage for persistence
//         sessionStorage.setItem("userRegion", userRegion);
//       }
  
//       return userRegion;
//     } catch (error) {
//       console.error("Error fetching user region:", error);
//       return "GB"; // Default to UK on error
//     }
//   };
  
//   // Load the correct Cognito configuration dynamically
//   export const getAuthConfig = async () => {
//     const userRegion = await detectUserRegion();
//     return regionConfig[userRegion] || regionConfig["GB"]; // Default to UK if unknown region

    
//   };
  
// export const regionConfig = {
//   US: {
//     aws_project_region: "us-west-2",
//     aws_cognito_region: "us-west-2",
//     aws_user_pools_id: "us-west-2_Vz5tDjg3y",
//     aws_user_pools_web_client_id: "5lj1cimcdk1p89r20ecpcqdh3b",
//     oauth: {
//       domain: "https://us-west-2vz5tdjg3y.auth.us-west-2.amazoncognito.com",
//       scope: ["email", "openid", "phone", "profile"],
//       responseType: "code",
//       redirectSignIn: "https://unicorn.srvql.com/",
//       redirectSignOut: "https://unicorn.srvql.com/",
//     },
//   },
//   IN: {
//     aws_project_region: "ap-south-1",
//     aws_cognito_region: "ap-south-1",
//     aws_user_pools_id: "ap-south-1_nbQYwCpEz",
//     aws_user_pools_web_client_id: "5tekknmkii3lpsamv4tasmd3ru",
//     oauth: {
//       domain: "https://ap-south-1nbqywcpez.auth.ap-south-1.amazoncognito.com",
//       scope: ["email", "openid", "phone", "profile"],
//       responseType: "code",
//       redirectSignIn: "https://unicorn.srvql.com/",
//       redirectSignOut: "https://unicorn.srvql.com/",
//     },
//   },
//   GB: {
//     aws_project_region: "eu-west-1",
//     aws_cognito_region: "eu-west-1",
//     aws_user_pools_id: "eu-west-1_dVg45Dujp",
//     aws_user_pools_web_client_id: "37s0h2sugb7fb4d141qknsr1q4",
//     oauth: {
//       domain: "https://servqualit.auth.eu-west-1.amazoncognito.com",
//       scope: ["email", "openid", "phone", "profile"],
//       responseType: "code",
//       redirectSignIn: "https://unicorn.srvql.com/",
//       redirectSignOut: "https://unicorn.srvql.com/",
//     },
//   },
//   AE: {
//     aws_project_region: "me-central-1",
//     aws_cognito_region: "me-central-1",
//     aws_user_pools_id: "me-central-1_JbYqzYCuw",
//     aws_user_pools_web_client_id: "35pq7v7sffiihk9lbqjuorpe1p",
//     oauth: {
//       domain: "https://me-central-1jbyqzycuw.auth.me-central-1.amazoncognito.com",
//       scope: ["email", "openid", "phone", "profile"],
//       responseType: "code",
//       redirectSignIn: "https://unicorn.srvql.com/",
//       redirectSignOut: "https://unicorn.srvql.com/",
//     },
//   },
// };

// // AWS → Business region mapping
// const awsToBusinessRegionMap = {
//   "us-west-2": "US",
//   "ap-south-1": "IN",
//   "eu-west-1": "GB",
//   "me-central-1": "AE",
// };

// /**
//  * ✅ Detect region from Cognito state param in redirect URL
//  */
// export const detectRegionFromStateParam = () => {
//   const hash = window.location.hash || "";
//   const match = hash.match(/state=([^&]+)/);

//   if (match && match[1]) {
//     try {
//       const decoded = decodeURIComponent(match[1]);
//       const stateObj = JSON.parse(decoded);
//       if (stateObj.region) {
//         sessionStorage.setItem("userRegion", stateObj.region);
//         console.log(`🌍 Saved region from state param: ${stateObj.region}`);
//         return stateObj.region;
//       }
//     } catch (err) {
//       console.warn("⚠️ Failed to parse region from state param:", err);
//     }
//   }

//   return null;
// };

// /**
//  * ✅ Detect region from Cognito domain (fallback)
//  */
// export const detectRegionFromCognitoUrl = () => {
//   let urlToCheck = document.referrer || "";
//   if (!urlToCheck.includes("amazoncognito.com")) {
//     urlToCheck = window.location.href;
//   }

//   const match = urlToCheck.match(/auth\.([a-z0-9-]+)\.amazoncognito\.com/);
//   if (match && match[1]) {
//     const awsRegion = match[1];
//     const shortRegion = awsToBusinessRegionMap[awsRegion];
//     sessionStorage.setItem("userRegion", shortRegion);
//     console.log(`🌍 Saved region from Cognito domain: ${shortRegion}`);
//     return shortRegion;
//   }

//   // Optional hostname fallback
//   const hostname = window.location.hostname.toLowerCase();
//   if (hostname.includes("in.")) return "IN";
//   if (hostname.includes("ae.")) return "AE";
//   if (hostname.includes("us.")) return "US";
//   if (hostname.includes("gb.") || hostname.includes("uk.")) return "GB";

//   return null;
// };

// /**
//  * ✅ Main function to get Amplify Auth config
//  * Combines state-based detection + domain fallback
//  */
// export const getAuthConfig = async () => {
//   // Try reading region from Cognito state first
//   let region = detectRegionFromStateParam();

//   // Fallback: use domain parsing
//   if (!region) {
//     region = detectRegionFromCognitoUrl();
//   }

//   // Default fallback
//   region = region || "GB";

//   sessionStorage.setItem("userRegion", region);
//   return regionConfig[region];
// };

// export const regionConfig = {
//   AP: {
//     aws_project_region: "ap-southeast-2",
//     aws_cognito_region: "ap-southeast-2",
//     aws_user_pools_id: "ap-southeast-2_3POcLxU4s",
//     aws_user_pools_web_client_id: "689baoimsmi285997eflt8hdqa",
//     oauth: {
//       domain: "ap-southeast-23poclxu4s.auth.ap-southeast-2.amazoncognito.com",
//       scope: ["email", "openid", "phone", "profile"],
//       responseType: "code",
//       redirectSignIn: "https://demo.securecloud.tech",
//       redirectSignOut: "https://demo.securecloud.tech",
//     },
//   },
export const regionConfig = {
  AP: {
    aws_project_region: "ap-southeast-2",
    aws_cognito_region: "ap-southeast-2",
    aws_user_pools_id: "ap-southeast-2_3POcLxU4s",
    aws_user_pools_web_client_id: "689baoimsmi285997eflt8hdqa",
    oauth: {
      domain: "https://ap-southeast-23poclxu4s.auth.ap-southeast-2.amazoncognito.com",
      scope: ["email", "openid", "phone", "profile"],
      responseType: "code",
      redirectSignIn: "https://demo.securecloud.tech",
      redirectSignOut: "https://demo.securecloud.tech",
    },
  },
};





//   IN: {
//     aws_project_region: "ap-south-1",
//     aws_cognito_region: "ap-south-1",
//     aws_user_pools_id: "ap-south-1_nbQYwCpEz",
//     aws_user_pools_web_client_id: "5tekknmkii3lpsamv4tasmd3ru",
//     oauth: {
//       domain: "https://ap-south-1nbqywcpez.auth.ap-south-1.amazoncognito.com",
//       scope: ["email", "openid", "phone", "profile"],
//       responseType: "code",
//       redirectSignIn: "https://unicorn.srvql.com/",
//       redirectSignOut: "https://unicorn.srvql.com/",
//     },
//   },
//   GB: {
//     aws_project_region: "eu-west-1",
//     aws_cognito_region: "eu-west-1",
//     aws_user_pools_id: "eu-west-1_dVg45Dujp",
//     aws_user_pools_web_client_id: "37s0h2sugb7fb4d141qknsr1q4",
//     oauth: {
//       domain: "https://servqualit.auth.eu-west-1.amazoncognito.com",
//       scope: ["email", "openid", "phone", "profile"],
//       responseType: "code",
//       redirectSignIn: "https://unicorn.srvql.com/",
//       redirectSignOut: "https://unicorn.srvql.com/",
//     },
//   },
//   AE: {
//     aws_project_region: "me-central-1",
//     aws_cognito_region: "me-central-1",
//     aws_user_pools_id: "me-central-1_JbYqzYCuw",
//     aws_user_pools_web_client_id: "35pq7v7sffiihk9lbqjuorpe1p",
//     oauth: {
//       domain: "https://me-central-1jbyqzycuw.auth.me-central-1.amazoncognito.com",
//       scope: ["email", "openid", "phone", "profile"],
//       responseType: "code",
//       redirectSignIn: "https://unicorn.srvql.com/",
//       redirectSignOut: "https://unicorn.srvql.com/",
//     },
//   },
// };

// 🔥 FIXED: Complete domain-to-region mapping
const domainToRegionMap = {
  
  "ap-southeast-23poclxu4s.auth.ap-southeast-2.amazoncognito.com": "AP",
  // "ap-south-1nbqywcpez.auth.ap-south-1.amazoncognito.com": "IN", 
  // "servqualit.auth.eu-west-1.amazoncognito.com": "GB",
  // "me-central-1jbyqzycuw.auth.me-central-1.amazoncognito.com": "AE"
};

// AWS → Business region mapping
const awsToBusinessRegionMap = {
  "ap-southeast-2": "AP",
  // "ap-south-1": "IN", 
  // "eu-west-1": "GB",
  // "me-central-1": "AE",
};

/**
 * ✅ MISSING FUNCTION: Detect region from Cognito state param in redirect URL
 */
// export const detectRegionFromStateParam = () => {
//   const hash = window.location.hash || "";
//   const match = hash.match(/state=([^&]+)/);

//   if (match && match[1]) {
//     try {
//       const decoded = decodeURIComponent(match[1]);
//       const stateObj = JSON.parse(decoded);
//       if (stateObj.region) {
//         sessionStorage.setItem("userRegion", stateObj.region);
//         console.log(`🌍 Saved region from state param: ${stateObj.region}`);
//         return stateObj.region;
//       }
//     } catch (err) {
//       console.warn("⚠️ Failed to parse region from state param:", err);
//     }
//   }

//   return null;
// };

/**
 * ✅ FIXED: Detect region from Cognito domain with proper regex patterns
 */
// export const detectRegionFromCognitoUrl = () => {
//   let urlToCheck = document.referrer || "";
//   if (!urlToCheck.includes("amazoncognito.com")) {
//     urlToCheck = window.location.href;
//   }

//   console.log("🔍 Checking URL for region:", urlToCheck);

//   // 🔥 METHOD 1: Direct domain matching (most reliable)
//   for (const [domain, region] of Object.entries(domainToRegionMap)) {
//     if (urlToCheck.includes(domain)) {
//       console.log(`✅ Found region ${region} from domain ${domain}`);
//       sessionStorage.setItem("userRegion", region);
//       return region;
//     }
//   }

//   // 🔥 METHOD 2: Multiple regex patterns to handle all domain formats
//   const patterns = [
//     // Pattern 1: poolid.auth.region.amazoncognito.com (US, IN, AE)
//     /([a-z0-9-]+[a-z0-9]+)\.auth\.([a-z0-9-]+)\.amazoncognito\.com/,
//     /auth\.([a-z0-9-]+)\.auth\.([a-z0-9-]+)\.amazoncognito\.com/,
//     // Pattern 2: customdomain.auth.region.amazoncognito.com (GB)
//     /([a-zA-Z0-9]+)\.auth\.([a-z0-9-]+)\.amazoncognito\.com/,
//     // Pattern 3: region extraction from any amazoncognito.com URL
//     /auth\.([a-z0-9-]+)\.amazoncognito\.com/
//   ];

//   for (const pattern of patterns) {
//     const match = urlToCheck.match(pattern);
//     if (match) {
//       const awsRegion = match[2] || match[1]; // Use second match group, fallback to first
//       const shortRegion = awsToBusinessRegionMap[awsRegion];
      
//       if (shortRegion) {
//         console.log(`✅ Found region ${shortRegion} from AWS region ${awsRegion}`);
//         sessionStorage.setItem("userRegion", shortRegion);
//         return shortRegion;
//       }
//     }
//   }

//   console.warn("⚠️ Could not detect region from URL patterns");
//   return null;
// };

/**
 * ✅ FIXED: Enhanced region detection with persistence
 */
// export const getAuthConfig = async () => {
//   console.log("🔍 Starting region detection...");

//   // 🔥 PRIORITY 1: Use stored original region (prevents cross-region issues)
//   let region = localStorage.getItem("userOriginalRegion");
//   if (region) {
//     console.log(`✅ Using stored original region: ${region}`);
//     sessionStorage.setItem("userRegion", region);
//     return regionConfig[region];
//   }
//   // PRIORITY 2: Try reading region from Cognito state
//   region = detectRegionFromStateParam();
//   if (region) {
//     console.log(`✅ Detected region from state param: ${region}`);
//     localStorage.setItem("userOriginalRegion", region);
//     sessionStorage.setItem("userRegion", region);
//     return regionConfig[region];
//   }

//   // PRIORITY 3: Fallback to domain parsing
//   region = detectRegionFromCognitoUrl();
//   if (region) {
//     console.log(`✅ Detected region from URL: ${region}`);
//     localStorage.setItem("userOriginalRegion", region);
//     sessionStorage.setItem("userRegion", region);
//     return regionConfig[region];
//   }

//   // PRIORITY 4: Hostname-based detection
//   const hostname = window.location.hostname.toLowerCase();
//   if (hostname.includes("ap.")) region = "AP";
//   // else if (hostname.includes("ae.")) region = "AE"; 
//   // else if (hostname.includes("us.")) region = "US";
//   // else if (hostname.includes("gb.") || hostname.includes("uk.")) region = "GB";

//   if (region) {
//     console.log(`✅ Detected region from hostname: ${region}`);
//     localStorage.setItem("userOriginalRegion", region);
//     sessionStorage.setItem("userRegion", region);
//     return regionConfig[region];
//   }

//   // 🚨 LAST RESORT: Log the fallback usage
//   console.warn("⚠️ NO REGION DETECTED - Using GB fallback. This may cause cross-region session issues!");
//   console.log("Debug info:", {
//     referrer: document.referrer,
//     currentUrl: window.location.href,
//     hostname: window.location.hostname
//   });
  
//  region = "AP";
// sessionStorage.setItem("userRegion", region);
// return regionConfig[region];
// };
export const getAuthConfig = async () => {
  const region = "AP"; // ✅ FORCE SINGLE REGION

  sessionStorage.setItem("userRegion", region);
  localStorage.setItem("userOriginalRegion", region);

  console.log("✅ Using fixed AP region");

  return regionConfig[region];
};




export const verifyRegionConsistency = () => {
  const storedRegion = localStorage.getItem("userOriginalRegion");
  const sessionRegion = sessionStorage.getItem("userRegion");
  
  console.log("🔍 Region consistency check:", {
    stored: storedRegion,
    session: sessionRegion,
    consistent: storedRegion === sessionRegion
  });

  return storedRegion === sessionRegion;
};
